import React from "react";
function NotFound() {
  return <h2>404 - Page Not Found</h2>;
}
export default NotFound;